export const manipulateuserdata = (type, payload) => {
  return {
    type: type,
    payload: payload,
  };
};
